import { render, staticRenderFns } from "./ScopeSelector.vue?vue&type=template&id=6a22ee14"
import script from "./ScopeSelector.vue?vue&type=script&lang=js"
export * from "./ScopeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports